import React, { useEffect, useState } from "react";
import user from "../../assets/img/user 1.svg";
import dele from "../../assets/img/slash.svg";
import edit from "../../assets/img/edit-3.svg";
import save from "../../assets/img/save.svg";
import greensave from "../../assets/img/greensave.svg";
import comm from "../../assets/img/message-circle.svg";
import like from "../../assets/img/heart.svg";
import likered from "../../assets/img/heart-red.svg";
import { formatDistanceToNow, formatDistance } from 'date-fns';
import "../../assets/css/text-limit.css";
import { BrowserRouter as Router, Switch, Route, Link, useNavigate } from 'react-router-dom';
import {
  getAllComments
} from "../../services/apiPosts";

import Button from 'react-bootstrap/Button';

const ListFeed = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [visibleComments, setVisibleComments] = useState({});
  const [showComment, SetShowComments] = useState([]);
  const [validationError, setValidationError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const post = props.post;
  const userData = props.userData;
  const profile_image_url = post?.user?.[0]?.profileImage?.url
    ? process.env.REACT_APP_IMAGE_URL + post.user[0].profileImage.url
    : user;
  const fullName = post.user[0].lastName ? `${post.user[0].firstName} ${post.user[0].lastName}`
                    : post.user[0].firstName;

  const toggleCommentsVisibility = async (postId) => {
    setVisibleComments((prev) => {
      const newVisibility = !prev[postId]; // Determine new visibility state
      // Call the API only if the new visibility state is true (i.e., comments are opening)
      if (newVisibility) {
        const comntpayload = { postid: postId };
        getAllComments(comntpayload).then(resComments => {
          SetShowComments(resComments.comments || []);
        }).catch(err => {
          console.error("Error fetching comments:", err);
        });
      }
      return {
        ...prev,
        [postId]: newVisibility, // Toggle visibility for the specific post
      };
    });
  };
  const handleLike = async (postId, status) => {

    try {
      await props.handleLike(postId);

      if (post.likes.length > 0) {
        if (status == false)
          post.likes[0].totallikes += 1;
        else {
          const dec_count = post.likes[0].totallikes -= 1;
          if (dec_count == 0)
            post.likes[0].totallikes = [];
          else
            post.likes[0].totallikes -= 0;
        }

      }
      else {
        post.likes = [{ totallikes: 1 }];
      }
    }
    catch (error) {

    }
  }



  const handleCommentSubmit = async (postId) => {

    
    setValidationError(false);
    const commentText = props.comment[postId] || '';
    if (!commentText.trim()) {
      setValidationError('Comment cannot be empty');
      return;
    }
    if (isSubmitting) return; // ⛔ Prevent double click
    setIsSubmitting(true);
    try {
     let response =  await props.handleCommentSubmit(postId);
      // After successful submission:
      // 1. Increment the comment count locally
      if(response && response.status === true){

         if (post.comments.length > 0) {
        post.comments[0].totalcomments += 1;
      } else {
        post.comments = [{ totalcomments: 1 }];
      }

      // 2. Refresh the comments list
      const comntpayload = { postid: postId };
      const resComments = await getAllComments(comntpayload);
      SetShowComments(resComments.comments || []);
        
      }
     
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
    // Toggle Comment
    await toggleCommentsVisibility(postId);

    setIsSubmitting(false); 
  };
  const slugify = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");


  const handleImageClick = (first, last, id,type) => {
    if(type === "individual"){
        const userName = `${slugify(first)}-${slugify(last)}`;
       if(userData._id === id)
       navigate('/profile');
       else
       navigate(`/profile/${userName}`, { state: { userId: id } })
    }else{
         if(userData._id === id)
         navigate('/organization');
        else
        navigate(`/organization/${slugify(first)}`, { state: { userId: id } })
    }
   
  };
  return (
    <div ref={ref} key={props.index} className="profile-section">
      <div className="single posts">
        <div className="user-post">
          <div className="p-img">
            <div className="post-avatr-wrap">
              {post.user[0].profileSettings.isPrivateProfile === false && post.user[0].profileSettings.showprofileImage === true ? (

                <img src={profile_image_url} className="avar-post" alt="User Profile"
                  style={{ cursor: "pointer", }} onClick={() => {
                    handleImageClick(post.user[0].firstName, post.user[0].lastName, post.user[0]._id,post.user[0].userType);
                  }}
                />
              ) : (
                <img src={user} className="avar-post" alt="User Profile"
                  style={{ cursor: "pointer", }} onClick={() => {
                    handleImageClick(post.user[0].firstName, post.user[0].lastName, post.user[0]._id,post.user[0].userType);
                  }} />
              )}

              {/* Dynamically set user name */}
              <span className="avatarname-post" style={{ cursor: "pointer", }}
                onClick={() => handleImageClick(post.user[0].firstName, post.user[0].lastName, post.user[0]._id,post.user[0].userType)}>
                {fullName}
                {/* Display Member Type */}</span>

              {post.usercommunities.length > 0 && post.usercommunities[0].membertype.length > 0 && post.usercommunities[0].membertype[0].memberTypeDisplayName !== "other" ?  (
                <span className="avatarname-wrp">{post.usercommunities[0].membertype[0].memberTypeDisplayName}</span>
              ) : (
                <span className="avatar-role"></span>
              )}
              {post.user[0]._id !== userData._id &&
              (
                (userData.userType === 'individual') ||
                (userData.userType === 'organization' && post.user[0].userType === 'organization')
              )?
                (
                <span
                  className="star-rating"
                  style={{ fontSize: '1rem', cursor: 'pointer', color: props.favourites[post.user[0]._id] ? '#ffc107' : '#e4e5e9' }}
                  onClick={() => {
                       
                    props.showFavourite(post.user[0]._id, fullName, post.favouritemember.length); // Show the favorite modal

                  }}>
                  &#9733;
                </span>) : (null)
              }

              <span className="timing">{formatDistanceToNow(new Date(post.createdAt), { addSuffix: true })}</span>
            </div>
          </div>
        </div>

        <div className="community-itmpost-right">
          <h5 className="comunity-name-post mb-0"></h5>
          {post.postcommunity && post.postcommunity.length > 0 && (
            <span className="user-role-wp border-0">{post.postcommunity.length > 0 ? post.postcommunity[0]?.communityName : ""}</span>
          )}

          {post.topic.length > 0 && (
             <span className="user-role-wp">{post.topic.length > 0 ? post.topic[0].topicTitle : ""}</span>
          )}
  
          
          <div className="moreoption">

            {post.user[0]._id === userData._id ? (
              <div class="dropdown">
                <button className="more" onClick={() => props.setShow(true)}>&#x22EE;</button>
                <div class="dropdown-content">
                  <Link className="button edit" onClick={(e) => { e.preventDefault(); props.handleEdit(post) }}>  <img src={edit} className="edit-img" alt="Comments" /> Edit</Link>

                  <Link className="button delet" onClick={(e) => { e.preventDefault(); props.DeletPost(post._id) }}>
                    <img src={dele} className="edit-img" alt="Comments" /> Delete</Link>
                </div>

              </div>
            ) : (
              <button className="more" onClick={() => props.showReport(post._id)}>&#x22EE;</button>
            )}

          </div>
        </div>
      </div>



      <p className="post-tittle"><strong>{post.postTitle}</strong></p>
      <div className="post-content" dangerouslySetInnerHTML={{ __html: post.postDescription }} />
      <div className="user-like_coment-share">
        <div className="like_comment">
          <div className="l-Cwrapper">
            <img src={comm} className="comment-icon" alt="Comments" /><span>{post.comments.length > 0 ? post.comments[0].totalcomments : ""}</span>
            <Link onClick={(e) => { e.preventDefault(); toggleCommentsVisibility(post._id) }}>Comments</Link>
          </div>
          <div className="l-Cwrapper ">
            <img
              src={props.likedPosts[post._id] ? likered : like}
              className="comment-icon"
              alt="Likes"
              onClick={() => handleLike(post._id, props.likedPosts[post._id])}
            /><span>{post.likes.length > 0 ? post.likes[0].totallikes : ""}</span>
            Likes
          </div>



        </div>

        <div className="savepost">
          <div className="post-saved">
            {(props.savedPost[post._id] || post.usersave.length > 0) ?
              (<>
                  <img src={greensave} className="save-img-post" alt="Save"/>
                  <span className="savetext">Save</span>
              </>
              
                
              ) : (
                <>
                 <img src={save} className="save-img-post" alt="Save"

                onClick={() => props.handleshortlist(post._id)} />
                <span className="savetext" onClick={() => props.handleshortlist(post._id)}>Save</span>
                </>
             )}

               

           
          </div>
        </div>
      </div>
      {/* Comment Input Section */}
      <div className="text-space comment-box-post">
        <textarea className={`coment-box ${validationError ? 'error' : ''} ${props.commentLimit?.isOverLimit ? 'limit-exceeded' : ''}`}
         id={`message-${post._id}`} name="message" rows="5" cols="40" placeholder="Add a comment" 
         value={props.comment[post._id] || ''} 
         onChange={(e) => props.handleCommentChange(post._id, e.target.value)}
         maxLength={props.maxCommentLength}></textarea>
        <div className="post-btn-conatiner mt-1 d-flex justify-content-end g-2">
          <Button variant="light" onClick={() => props.handleCommentClear(post._id)}>Clear</Button>
          <Button variant="primary" disabled={isSubmitting}  onClick={() => handleCommentSubmit(post._id)}>Post now</Button>
           <div className={`character-counter ${props.commentLimit?.isOverLimit ? 'text-danger' : 'text-muted'}`}>
    {props.commentLimit?.remaining ?? props.maxCommentLength}  characters remaining
    {props.commentLimit?.isOverLimit && (
      <span className="limit-warning"> (Maximum limit reached)</span>
    )}
  </div>
        </div>
        {/* List Comments Section */}
        {visibleComments[post._id] && showComment.length > 0 && (
          <div>{/* Wrap the elements in a parent div */}
            <h6>Comments</h6>
            <div className="comments-wrapper">
              {showComment.map((comment, index) => (

                <div key={index} className="comment-itm d-flex">
                  {comment.userId.profileImage ? (
                    comment.userId.profileSettings.isPrivateProfile === false &&
                      comment.userId.profileSettings.showprofileImage === true ? (
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + comment.userId.profileImage.url}
                        className="avar-logo people-user comment"
                        alt="User"
                      />
                    ) : (
                      <img src={user} className="avar-logo people-user comment" alt="User" />
                    )
                  ) : (
                    <img src={user} className="avar-logo people-user comment" alt="User" />
                  )}

                  <div className="coment-box d-flex flex-column">
                    <div className="text-comment d-flex justify-content-between">
                      <div className="avatar_name">{comment.userId.firstName} {comment.userId.lastName}</div>
                      <span className="date-sec"> {formatDistanceToNow(new Date(comment.createdAt), { addSuffix: true })}</span>
                    </div>
                    <p>{comment.comment}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>


    </div>
  )


});
export default ListFeed;